module.exports = __webpack_public_path__ + "img/high-voltage.8e11df34.png";